// TOP LEVEL IMPORTS
import React from 'react';
// ANTD
import Table from 'antd/lib/table';
// APOLLO
import { graphql } from 'react-apollo';
import invoicesByClientIdQuery from 'ApolloClient/Queries/invoicesByClientId'
// COMPONENTS
import CreateInvoiceButton from './CreateInvoiceButton';
import SectionRow from 'components/common/SectionRow';
import SectionHeader from 'components/text/SectionHeader';
import windowSize from 'react-window-size';

import columns from './columns';

class ClientInvoices extends React.PureComponent {
  render() {
      const { currentUser, windowWidth, clientId } = this.props;
      const showCols =
      windowWidth < 789
        ? ['number', 'amount', 'status', 'actions'] // mobile
        : ['number', 'amount', 'paidOn', 'sentOn', 'status', 'actions']; // desktop
    return (
      <SectionRow>
        <div>
          <SectionHeader>INVOICES</SectionHeader>
            {(currentUser && currentUser.paypalSet) || (currentUser && currentUser.organization && currentUser.organization.stripeUserIdExists) ? (
              <CreateInvoiceButton clientId={clientId} />
            ): null}
        </div>
        <Table
          rowKey={record => record._id}
          columns={columns({ showCols })}
          dataSource={this.props.invoicesByClientIdQuery.invoicesByClientId}
          pagination={{ defaultPageSize: 5 }}
        />
      </SectionRow>
    );
  }
}

const options = props => ({ variables: { _id: props.clientId } });

export default graphql(invoicesByClientIdQuery, { options, name: 'invoicesByClientIdQuery'})(ClientInvoices);



// WEBPACK FOOTER //
// ./src/routes/app-client-detail/ClientInvoices/index.js